import { supabase } from "./client";
import { getAuthRedirectUrl, isNative } from "../lib/platform";

export const signUp = (email: string, password: string) =>
  supabase.auth.signUp({
    email,
    password,
    // On native iOS, redirect to the custom URL scheme so the app opens
    // via deep link after email verification.
    // On web, redirect to the current origin.
    options: { emailRedirectTo: `${getAuthRedirectUrl()}?auth=verified` },
  });

export const signIn = (email: string, password: string) =>
  supabase.auth.signInWithPassword({ email, password });

export const signInWithMagicLink = (email: string) =>
  supabase.auth.signInWithOtp({
    email,
    options: {
      shouldCreateUser: true,
      emailRedirectTo: `${getAuthRedirectUrl()}?auth=verified`,
    },
  });

export const signOut = () => supabase.auth.signOut();

export const getSession = () => supabase.auth.getSession();

export const resetPassword = (email: string) => {
  const base = getAuthRedirectUrl();
  const redirectTo = isNative
    ? `${base}?auth=recovery`
    : `${base.replace(/\/$/, "")}/reset-password?auth=recovery`;

  return supabase.auth.resetPasswordForEmail(email, { redirectTo });
};

export const updatePassword = (password: string) =>
  supabase.auth.updateUser({ password });

export async function deleteAccount(): Promise<void> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error("Not signed in");

  let token = session.access_token;
  if ((session.expires_at ?? 0) * 1000 - Date.now() < 60_000) {
    const { data, error } = await supabase.auth.refreshSession();
    if (error || !data.session) throw new Error("Session expired, please sign in again.");
    token = data.session.access_token;
  }

  const res = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/delete-account`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!res.ok) {
    if (res.status === 401 || res.status === 403) throw new Error("Session expired, please sign in again.");
    throw new Error(await res.text());
  }
}
